import { type PropsWithChildren, useRef, useEffect } from 'react';
import { Animated, Keyboard, type KeyboardEvent, Easing } from 'react-native';

// iOS keyboard animation curve (matches CAMediaTimingFunction used by iOS)
const IOS_KEYBOARD_EASING = Easing.bezier(0.36, 0.66, 0.04, 1);

export function ScreenKeyboardAvoidingView({
    safeAreaBottomInset,
    children,
}: PropsWithChildren<{ safeAreaBottomInset?: number }>) {
    const keyboardHeight = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        const showSubscription = Keyboard.addListener(
            'keyboardWillShow',
            (event: KeyboardEvent) => {
                Animated.timing(keyboardHeight, {
                    toValue: event.endCoordinates.height - (safeAreaBottomInset ?? 0),
                    duration: event.duration,
                    easing: IOS_KEYBOARD_EASING,
                    useNativeDriver: false,
                }).start();
            },
        );

        const hideSubscription = Keyboard.addListener(
            'keyboardWillHide',
            (event: KeyboardEvent) => {
                Animated.timing(keyboardHeight, {
                    toValue: 0,
                    duration: event.duration,
                    easing: IOS_KEYBOARD_EASING,
                    useNativeDriver: false,
                }).start();
            },
        );

        return () => {
            showSubscription.remove();
            hideSubscription.remove();
        };
    }, [keyboardHeight, safeAreaBottomInset]);

    return (
        <Animated.View style={{ flex: 1, paddingBottom: keyboardHeight }}>{children}</Animated.View>
    );
}
